import { SxProps } from '@mui/material';

export const colorsPaletteGridRenderColorSx = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
};

export const colorPaletteSelectColorRenderColorSx = ({
	isMobile,
	color,
}: {
	isMobile: boolean;
	color?: string;
}): SxProps => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: 40,
	height: 40,
	border: 2,
	borderColor: 'grey.100',
	borderRadius: '50%',
	cursor: 'pointer',
	backgroundColor: color,
	backdropFilter: 'blur(10px)',
	boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
	transition: !isMobile ? 'transform 0.3s ease' : '',
	'&:hover': {
		transform: !isMobile ? 'scale(1.2)' : '',
	},
});

export const colorPaletteTypographyNameRenderColorSx = {
	mt: 0.5,
	color: 'grey.200',
};

export const colorsPaletteContainerSx = {
	padding: '10px',
};

export const colorsPaletteTitleSx = {
	mb: '10px',
	display: 'flex',
	gap: '5px',
};

export const colorPaletteSlicedGridSx = {
	mb: '15px',
};
